<template>
    <div>
        <!--Edit-->
        <Loader v-if="isLoading"></Loader>
        <div class="container">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Cadastro de Chamados</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item">Cadastro de chamados
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-form>
                                    <v-container>
                                        <div class="row">
                                            <div class="col-md-4 col-lg-4" v-show="false">
                                                <div class="form-group">
                                                    <label>Idenficador</label>
                                                    <input v-model="Chamado.sccId" type="text" class="form-control"
                                                        placeholder="Id" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <label>Tipo de Chamado</label>
                                                    <select v-model="Chamado.stcId" class="form-select form-control"
                                                        @change="BuscaStatusChamado()">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListTiposChamados"
                                                            :key="optionTipo.stcId" :value="optionTipo.stcId">{{
                                                            optionTipo.stcNomeTipoChamado }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-lg-3">
                                                <div class="form-group">
                                                    <label>Data Ocorrido</label>
                                                    <input v-model="Chamado.sccDataOcorrido" type="date"
                                                        class="form-control" placeholder="Data Ocorrido" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <label>Urgência</label>
                                                    <select v-model="Chamado.sccUrgencia"
                                                        class="form-select form-control">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListUrgencias" :key="optionTipo.Id"
                                                            :value="optionTipo.Id">{{ optionTipo.Nome }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <label>Solicitante</label>
                                                    <input v-model="Chamado.sccNomeSolicitante" type="text"
                                                        class="form-control" placeholder="Solicitante" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <label>Whatsapp</label>
                                                    <input v-model="Chamado.sccTelefoneSolicitante" type="text"
                                                        v-mask="'(##) #####-####'" class="form-control"
                                                        placeholder="Whatsapp" />
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-lg-4">
                                                <div class="form-group">
                                                    <label>E-mail</label>
                                                    <input v-model="Chamado.sccEmailSolicitante" type="text"
                                                        class="form-control" placeholder="E-mail" />
                                                </div>
                                            </div>
                                            <div class="col-md-8 col-lg-8">
                                                <div class="form-group">
                                                    <label>Título Chamado</label>
                                                    <input v-model="Chamado.sccTituloChamado" type="text"
                                                        maxlength="100" class="form-control"
                                                        placeholder="Título Chamado" />
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="form-group">
                                                    <label>Texto Chamado</label>
                                                    <ckeditor :editor="editor" @ready="onReady"
                                                        v-model="Chamado.sccTextoChamado" :config="$ckconfig">
                                                    </ckeditor>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12" v-if="User.garId == 0">
                                                <div class="form-group">
                                                    <h2>Informações Adicionais</h2>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6" v-if="User.garId == 0">
                                                <div class="form-group">
                                                    <label>Garantidora</label>
                                                    <select v-model="Chamado.garId" class="form-select form-control"
                                                        @change="BuscaImobialiarias()">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListGarantidoras"
                                                            :key="optionTipo.garId" :value="optionTipo.garId">{{
                                                            optionTipo.garNomeEmpresa }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6"
                                                v-if="Chamado.garId != null && ListImobiliarias != '' && User.garId == 0">
                                                <div class="form-group">
                                                    <label>Imobiliaria</label>
                                                    <select v-model="Chamado.imoId" class="form-select form-control"
                                                        @change="SelecionarConsumidor()">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListImobiliarias"
                                                            :key="optionTipo.imoId" :value="optionTipo.imoId">{{
                                                            optionTipo.nomeConcatenado }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6" v-if="Chamado.imoId != null && User.garId == 0">
                                                <div class="form-group">
                                                    <label>Cliente</label>
                                                    <select v-model="Chamado.cliId" @change="SelecionarPedidos()"
                                                        class="form-select form-control">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListClientes"
                                                            :key="optionTipo.cliId" :value="optionTipo.cliId">{{
                                                            optionTipo.nomeConcatenado }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6" v-if="Chamado.cliId != null && User.garId == 0">
                                                <div class="form-group">
                                                    <label>Contratação</label>
                                                    <select v-model="Chamado.pedId" class="form-select form-control">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListPedidos"
                                                            :key="optionTipo.pedId" :value="optionTipo.pedId">{{
                                                            optionTipo.nomeConcatenado }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="form-group">
                                                    <h2>Adicionar Anexos</h2>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row">
                                            <v-col cols="12" md="5">
                                                <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                    PDF</label>
                                                <v-file-input v-model="selectedFile" label="Selecione o arquivo"
                                                    variant="underlined" prepend-icon="mdi-file"
                                                    accept="image/*,application/pdf"></v-file-input>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <button type="button" class="btn btn-info"
                                                    @click.prevent="InserirDocumento()"
                                                    style="color:#ffffff;margin-top: 20px;">
                                                    Inserir
                                                </button>
                                            </v-col>
                                        </div>
                                        <div class="row">
                                            <v-table>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">
                                                            Documento
                                                        </th>
                                                        <th>
                                                            Ações
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in ListDocumentos" :key="index">
                                                        <td>{{ item.sdcUrlDocumento }}</td>
                                                        <td>
                                                            <v-btn icon @click.prevent="DeleteDocumento(index)"
                                                                variant="text">
                                                                <v-icon>mdi-delete-forever-outline</v-icon>
                                                                <v-tooltip activator="parent"
                                                                    location="top">Excluir</v-tooltip>
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 col-lg-12"
                                                style="text-align: right;padding-top: 40px;">
                                                <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                                                <button type="button" class="btn btn-success" style="color:#ffffff;"
                                                    @click="CadastrarChamado()">
                                                    Cadastrar Chamado
                                                </button>
                                            </div>
                                        </div>
                                    </v-container>
                                </v-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Loader from '../../components/PageLoader.vue'
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
    name: 'CadastroChamadosView',
    components: {
        moment,
        Loader,
        EasyDataTable
    },
    data: () => ({
        isLoading: false,
        editor: DecoupledEditor,
           User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        Chamado: {
            sccId: 0,
            sccDataCriacao: '',
            sccNomeSolicitante: '',
            sccTelefoneSolicitante: '',
            sccEmailSolicitante: '',
            sccTituloChamado: '',
            sccTextoChamado: '',
            sccDataOcorrido: '',
            sccTipo: '',
            sccUrgencia: null,
            tpeId: '',
            cusId: '',
            pesPesId: '',
            garId: null,
            imoId: null,
            parId: '',
            cliId: null,
            pedId: null,
            stcId: null,
            sscId: '',
        },
        //dados
        ListTiposChamados: [],
        ListUrgencias: [
            { Id: 1, Nome: 'Baixa' }, { Id: 2, Nome: 'Média' }, { Id: 3, Nome: 'Alta' }
        ],
        Garantidora: {},
        ListGarantidorasGeral: [],
        ListImobiliariaGeral: [],
        ListParceirosGeral: [],
        ListClientesGeral: [],
        ListPedidosGeral: [],
        ListGarantidoras: [],
        ListImobiliarias: [],
        ListParceiros: [],
        ListClientes: [],
        ListPedidos: [],
        ListDocumentos: [],
        Documento: {
            sdcId: 0,
            sdcDataCriacao: '',
            sdcUrlDocumento: '',
            sccId: null,
            sfcId: null
        },
        selectedFile: '',
        StatusChamados: [],
        Usuarios: [],
        Usuario: [],
        TipoPessoas: [],
    }),
    methods: {
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/CadastroChamados/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/CadastroChamados/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
            },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditCancel() {
            this.$router.go(0);
        },
        async BuscaImobialiarias() {
            if (this.Chamado.garId != '' && this.Chamado.garId != null) {
                this.Chamado.imoId = null;
                this.ListImobiliarias = [];
                this.ListClientes = [];
                this.ListPedidos = [];
                await axios.get(`/Telas/CadastroChamados/GetByGarIdParIdImobiliarias/` + this.Chamado.garId + '/0')
                    .then(response => {
                        this.ListImobiliariaGeral = response.data;
                        this.ListImobiliarias = this.ListImobiliariaGeral.filter(x => x.imoAtivo && x.imoVisivel);  //imobiliaria
                        this.ListImobiliarias = this.ListImobiliarias.map(item => {
                            return {
                                ...item,
                                nomeConcatenado: `${item.imoId} - ${item.imoNomeEmpresa} - ${item.imoDocumento}`
                            };
                        });

                        if (this.User.tpeid == 3) {
                            this.ListImobiliarias = this.ListImobiliarias.filter(x => x.imoId == this.User.pesid)
                            this.Chamado.imoId = this.ListImobiliarias[0].imoId;
                            this.SelecionarConsumidor();
                        }
                    });
            }
        },
        //consumidor
        SelecionarConsumidor() {
            if (this.Chamado.imoId != '' && this.Chamado.imoId != null) {
                this.Chamado.cliId = null;
                this.ListClientes = [];
                this.ListPedidos = [];
                axios.get(`/Telas/CadastroChamados/GetByGarIdImoIdClientes/0/` + this.Chamado.imoId)
                    .then(response => {
                        this.ListClientes = response.data.filter(x => x.cliAtivo);;  //consumidor
                        this.ListClientes = this.ListClientes.map(item => {
                            return {
                                ...item,
                                nomeConcatenado: `${item.cliId} - ${item.cliNomeEmpresa} - ${item.cliDocumento}`
                            };
                        });
                    });
            }
        },
        SelecionarPedidos() {
            if (this.Chamado.cliId != '' && this.Chamado.cliId != null) {
                this.Chamado.pedId = null;
                this.ListPedidos = [];
                axios.get(`/Telas/CadastroChamados/GetAllByCliIdPedidos/` + this.Chamado.cliId)
                    .then(response => {
                        this.ListPedidos = response.data;
                        this.ListPedidos = this.ListPedidos.map(item => {
                            return {
                                ...item,
                                nomeConcatenado: `${item.pedId} - ${this.formattedDate(item.pedDataPedido)} - ${item.pedSituacaoPedido}`
                            };
                        });
                    });
            }
        },
        async BuscaStatusChamado() {
            await axios.get(`/Telas/CadastroChamados/GetAllByStcIdStatusChamados/` + this.Chamado.stcId)
                .then(response => {
                    this.StatusChamados = response.data.sort((a, b) => {
                        const valorA = parseInt(a.pedId) || 0;
                        const valorB = parseInt(b.pedId) || 0;
                        return valorA - valorB;
                    });
                    console.log('StatusChamados')
                    console.log(this.StatusChamados)
                });

        },
        async InserirDocumento() {
        if (this.selectedFile !== '' && this.selectedFile !== null) {
            try {
            const uploadSuccess = await this.UploadImg(this.selectedFile[0]);

            if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
                this.Documento.sdcUrlDocumento = uploadSuccess.data.nameFile;
                this.Documento.sdcDataCriacao = moment().format('YYYY-MM-DDTHH:mm:ss');

                // Adiciona cópia do documento à lista
                this.ListDocumentos.push({ ...this.Documento });

                // Limpa seleções
                this.selectedFile = '';
                this.Documento = {};
            } else {
                this.$mensagemErro("Erro inesperado ao processar o arquivo. Tente novamente.");
            }
            } catch (error) {
            // Trata erro retornado pelo backend (ex: BadRequest)
            const mensagem = error.response?.data || "Erro ao enviar o documento.";
            this.$mensagemErro(mensagem);
            }
        } else {
            this.$mensagemAviso("Selecione o Documento a ser enviado.");
        }
        },
        DeleteDocumento(index) {
            this.ListDocumentos.splice(index, 1);
        },
        async CadastrarChamado() {
            this.startLoading();

            // Validações de campos obrigatórios
            if (!this.Chamado.stcId) {
                this.$mensagemAviso("Selecione o tipo de chamado.");
                this.stopLoading();
                return;
            }
            if (!this.Chamado.sccDataOcorrido) {
                this.$mensagemAviso("Digite data do ocorrido.");
                this.stopLoading();
                return;
            }
            if (!this.Chamado.sccNomeSolicitante) {
                this.$mensagemAviso("Nome Solicitante Obrigatório.");
                this.stopLoading();
                return;
            }
            if (!this.Chamado.sccTelefoneSolicitante) {
                this.$mensagemAviso("Whatsapp Solicitante Obrigatório.");
                this.stopLoading();
                return;
            }
            if (!this.Chamado.sccEmailSolicitante) {
                this.$mensagemAviso("E-mail Solicitante Obrigatório.");
                this.stopLoading();
                return;
            }
            if (!this.Chamado.sccTituloChamado) {
                this.$mensagemAviso("Título Chamado Obrigatório.");
                this.stopLoading();
                return;
            }
            if (!this.Chamado.sccTextoChamado) {
                this.$mensagemAviso("Descreva Chamado.");
                this.stopLoading();
                return;
            }

            // Preenche campos adicionais antes de gravar
            this.Chamado.sccDataCriacao = moment().format("YYYY-MM-DDTHH:mm:ss");
            this.Chamado.tpeId = this.User.tpeid;
            this.Chamado.pesPesId = this.User.pesid;
            this.Chamado.cusId = this.User.cusid;
            this.Chamado.parId = null;
            this.Chamado.sccTipo = 0;
            this.Chamado.sscId = this.StatusChamados[0].sscId;

            try {
                // Grava o chamado e obtém o ID gerado
                const resp = await axios.post(`/Telas/CadastroChamados/AddSupControleChamados`, this.Chamado);
                if (resp.data > 0) {
                    this.Chamado.sccId = resp.data;

                    // Para cada documento, grava em SupDocumentosChamados (sem bloquear o fluxo)
                    this.ListDocumentos.forEach((element) => {
                        const _documentoChamado = {
                            sdcId: 0,
                            sdcDataCriacao: element.sdcDataCriacao,
                            sdcUrlDocumento: element.sdcUrlDocumento,
                            sccId: this.Chamado.sccId,
                            sfcId: null,
                        };
                        axios
                            .post(`/Telas/CadastroChamados/AddSupDocumentosChamados`, _documentoChamado)
                            .catch((err) => console.error("Erro ao gravar documento:", err));
                    });

                    // Aguarda o envio de e-mails antes de redirecionar
                    await this.ValidaRegraEnvio();

                    this.$mensagemAviso("Chamado criado com sucesso.");
                    this.$router.push("/ChamadosAndamento");
                }
            } catch (err) {
                console.error("Erro ao cadastrar chamado:", err);
                // Aqui você pode exibir uma mensagem de erro genérica ou personalizada
            } finally {
                this.stopLoading();
            }
        },
        async ValidaRegraEnvio() {
            try {
                debugger;
                // Busca em paralelo os tipos de pessoas e os usuários
                const [tpResp, usrResp] = await Promise.all([
                    axios.get(`/Telas/CadastroChamados/GetAllTipoPessoas`),
                    axios.get(`/Telas/CadastroChamados/GetAllCadastroUsuarios`),
                ]);

                this.TipoPessoas = tpResp.data;
                this.Usuarios = usrResp.data;

                // Filtra a lista de destinatários com base em tpeId e tusId de StatusChamados[0]
                const filtroStatus = this.StatusChamados[0];
                  let destinatarioemailList = [];
                  if (filtroStatus.tpeId == 5){
                     destinatarioemailList = [ this.Chamado.sccEmailSolicitante ];
                  }
                  else{
                    destinatarioemailList = this.Usuarios
                        .filter(
                            (u) => u.tpeId === filtroStatus.tpeId && u.admTipoUsuario.tusId === filtroStatus.tusId
                        )
                        .map((u) => u.cusEmail); 
                  }

                if (!destinatarioemailList.length) {
                    console.warn("Nenhum destinatário encontrado para envio de e-mail.");
                    return;
                }

                // Monta dados para passar ao envio de e-mail
                const _nomede = this.Chamado.sccNomeSolicitante;
                const tipoChamado = this.ListTiposChamados.find(
                    (x) => x.stcId === this.StatusChamados[0].stcId
                );
                const _assuntotexto = `${tipoChamado.stcNomeTipoChamado} - ${this.Chamado.sccNomeSolicitante}`;
                const _codChamado = this.Chamado.sccId;
                const _newstatus = this.StatusChamados[0].sscNomeEtapa;

                // Define nomePara conforme tpeId
                let _nomepara = "";
                switch (filtroStatus.tpeId) {
                    case 1:
                        _nomepara = "Garantidora";
                        break;
                    case 2:
                        _nomepara = "Parceiro";
                        break;
                    case 3:
                        _nomepara = "Imobiliária";
                        break;
                    case 4:
                        _nomepara = "Cliente";
                        break;
                    case 5:
                        _nomepara = this.Chamado.sccNomeSolicitante;
                        break;
                    default:
                        _nomepara = "GarantePay";
                }

                // Aguarda o envio de e-mail para todos os destinatários
                await this.EnviaAvisoStatusChamado(
                    _nomede,
                    _nomepara,
                    _assuntotexto,
                    destinatarioemailList,
                    _codChamado,
                    _newstatus
                );
            } catch (err) {
                console.error("Erro em ValidaRegraEnvio:", err);
                // Se der erro aqui, o fluxo de CadastrarChamado vai continuar após o catch
            }
        },
        async EnviaAvisoStatusChamado(
            nomede,
            nomepara,
            assuntotexto,
            destinatarioemailList,
            codChamado,
            newstatus
        ) {
            try {
                // Busca todos os templates e filtra o de mpdId = 19
                const tmplResp = await axios.get(`/Telas/CadastroChamados/GetByIdMensagemPadrao/19`);
                this.templateEmail = tmplResp.data;
                const textoBase = this.templateEmail.mpdTexto;
                // Para cada destinatário, monta o objeto e chama o POST de envio
                const promessasDeEnvio = destinatarioemailList.map((dest) => {
                    const _dadosEmail = {
                        nomeDe: nomede,
                        nomePara: nomepara,
                        assunto: assuntotexto,
                        destinatario: dest,
                        emailResposta: this.$GarantePayEmail,
                        textoEmail: textoBase
                            .replace("[CodChamado]", codChamado)
                            .replace("[NovoStatus]", newstatus)
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                            listAnexos: null
                    };

                    return axios
                        .post(`/Telas/CadastroChamados/Enviamail`, _dadosEmail)
                        .then((res) => {
                            if (res.data == 1) {
                                console.log(`E-mail enviado para ${dest}`);
                            } else {
                                console.warn(`Falha ao enviar para ${dest}: resposta =`, res.data);
                            }
                        })
                        .catch((err) => {
                            console.error(`Erro no envio para ${dest}:`, err);
                        });
                });

                // Aguarda todas as requisições de e-mail (OK ou falha)
                await Promise.all(promessasDeEnvio);
            } catch (err) {
                console.error("Erro em EnviaAvisoStatusChamado:", err);
            }
        },
        async Get() {
           await axios.get(`/Telas/CadastroChamados/GetDados`)
               .then(response => {
                 this.ListTiposChamados = response.data.subtiposChamados;
                 this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garAtivo);
                 this.ListGarantidoras = this.ListGarantidorasGeral;
                  this.ListImobiliariasGeral = response.data.imoImobiliarias.filter(x => x.imoAtivo);
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;
                    this.User.pesid = response.data.pesId;
                    this.User.cusid = response.data.cusId;
           });

        }
    },
    created() {
        this.Get();

    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
